<div class="screen-element toast-screen">
  @if ( showIconBar) {
    <div class="iconbar">
      <iconbar></iconbar>@if (menuIcon) {
      <span class="menu-icon inline-icon {{menuIcon}}">&nbsp;</span>
    }
  </div>
}
<div class="title"
  [ngClass]="{'darkTitle':hasParameter('darkTitle')||hasParameter('darkTitleOnly'),'darkerTitle':hasParameter('darkerTitle')||hasParameter('darkerTitleOnly')}">
  {{title}}
  @if(titleIcon() != ''){
    <span class="menu-icon inline-icon {{titleIcon()}}">&nbsp;</span>
  }
</div>
@if ( !hasParameter('normalCaseSubtitle')) {
  <div class="subtitle"
    [ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle'),'light':hasParameter('lightSubtitle')}">
    {{getSubtitle()|uppercase}}
  </div>
}
@if (hasParameter('normalCaseSubtitle')) {
  <div class="subtitle"
    [ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle'),'light':hasParameter('lightSubtitle')}">
  {{getSubtitle()}}</div>
}
<div class="dashboard-center">
  @if (value !== undefined) {
    <div class="value" [ngClass]="{ 'small' : hasParameter('smallValue') }">{{value}}
    </div>
  }
  @if (unit) {
    <div class="unit">{{unit}}</div>
  }
  @if (dashIcon) {
    <div class="icon {{dashIcon}}"
      [ngClass]="{'bigDashIcon':hasParameter('bigDashIcon'),'veryBigDashIcon':hasParameter('veryBigDashIcon')}">
    </div>
  }
</div>
<div class="text text-1"><text-widget [color]="getColor(1)" [text]="getText(0)"></text-widget></div>
<div class="text text-2"><text-widget [color]="getColor(2)" [text]="getText(1)"></text-widget></div>
<div class="text text-3"><text-widget [color]="getColor(3)" [text]="getText(2)"></text-widget></div>
<!--
<div class="text text-1">{{menuService.getText(0)}}</div>
<div class="text text-2">{{menuService.getText(1)}}</div>
<div *ngIf="!menuService.hasParameter('yes-no-button')" class="text text-3">{{menuService.getText(2)}}</div>
<div *ngIf="menuService.hasParameter('yes-no-button')" class="text text-3">
  <span class="inline-icon iconBack vaillant-grey-50">&nbsp;</span><span class="vaillant-grey-50">Nein</span>&nbsp;
  <span class="inline-icon iconCheckConfirm vaillant-grey-50">&nbsp;</span><span class="vaillant-grey-50">Ja</span>
</div>
-->
</div>